module.exports = __webpack_public_path__ + "img/Content2.29b1dfd6.png";